import { render, staticRenderFns } from "./OwalTab.vue?vue&type=template&id=1fe3758a&scoped=true"
import script from "./OwalTab.vue?vue&type=script&lang=js"
export * from "./OwalTab.vue?vue&type=script&lang=js"
import style0 from "./OwalTab.vue?vue&type=style&index=0&id=1fe3758a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe3758a",
  null
  
)

export default component.exports